import { render } from "./PaymentsIndexTable.vue?vue&type=template&id=4675de5c"
import script from "./PaymentsIndexTable.vue?vue&type=script&lang=js"
export * from "./PaymentsIndexTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__